<template>
  <section class="page-index" :style="gradientStyle">
    <!-- 内容 -->
    <div class="page-index-bg">
      <div class="page-index-wrap">
        <div class="btn-home" @click="handleHome">
          <span class="arr01"></span>
          <span class="arr02" :style="gradientHomeBtnStyle"></span>
          <span class="arr03"></span>
        </div>
        <!-- 活动内容 -->
        <div class="cont">
          <!-- 头部banner信息 -->
          <div class="head">
            <div class="banner">
              <van-image
                class="s"
                :src="superInfo.activityBigImg"
                fit="cover"
              />
            </div>
            <div class="txt-box">
              <div class="tit text-line-2">
                {{ superInfo.activityName }}
              </div>
              <div class="t1 text-line-2" :style="{ color: bgColor }">
                {{ superInfo.artistNameList }}
              </div>
              <div v-if="actTime" class="t2">{{ actTime }}</div>
              <div class="t3">{{ superInfo.location }}</div>
            </div>
          </div>
          <!-- 活动卡片 模块 -->
          <v-mod-coupon
            v-if="superInfo.activityId"
            :superInfo="superInfo"
            :actInfo="actInfo"
          />

          <!-- 报名和开奖时间 -->
          <div class="time-box" id="setAnchor">
            <div class="time">
              <div class="tit">
                <div class="s">报名时间<span class="line"></span></div>
              </div>
              <div class="txt">{{ signUpStartTime }} - {{ signUpEndTime }}</div>
            </div>
            <div class="gift">
              <div class="tit" :style="getTimeTitStyle"></div>
              <div class="txt">
                <div v-if="superInfo.activityCategory == 2" class="txt">
                  {{ drawStartTime }}
                </div>
                <div v-else class="day">
                  {{ drawStartTime }} - {{ drawEndTime }}
                </div>
                <div v-if="isRemind" class="order" @click="handleRemind">
                  提醒我开奖
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 开奖规则 -->
        <div class="rule-box" v-if="superInfo.drawRule">
          <van-image class="s" :src="superInfo.drawRule" fit="cover" />
        </div>

        <!-- 底部按钮 -->
        <v-mod-ft-btn
          v-if="superInfo.activityId"
          :superInfo="superInfo"
          :actInfo="actInfo"
          :isHit="isHit"
          @showSignUpPopup="showSignUpPopup"
          @handleAddPopup="handleAddPopup"
          @handleOpenGift="handleOpenGift"
          @handleContinue="handleContinue"
          @refresh="refreshSuperInfo"
          @handleJumpPopup="handleJumpPopup"
          @handleBlind="handleBlind"
          :isSearching="isSearching"
        />

        <div v-if="!showEmpty" class="section-header more-post">更多内容</div>
        <post-list
          v-show="!showEmpty"
          :post-list="postList"
          @load-post="loadPosts"
          ref="post-list"
          :auto-load="false"
        />
      </div>
    </div>

    <!-- 中奖弹窗 -->
    <v-pop-gift
      ref="popgift"
      :superInfo="superInfo"
      :actTime="actTime"
      :bgColor="bgColor"
      @handleConfirm="giftConfirm"
    />

    <!-- 新人福利弹窗 -->
    <v-pop-img ref="popimg" />

    <!-- 报名确认弹窗 -->
    <v-pop-reg
      ref="popreg"
      v-if="superInfo.activityId"
      @goCert="openCertPop"
      @success="regSuccess"
      :superInfo="superInfo"
    />

    <!-- 报名身份认证弹窗 -->
    <v-pop-cert
      ref="popcert"
      v-if="superInfo.activityId"
      @picker="openPickerPop"
      @success="refreshSuperInfo"
      :superInfo="superInfo"
      :pickerValue="pickerValue"
    />

    <!-- 证件类型选择弹窗 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <!-- 报名确认弹窗 -->
    <v-pop-add
      ref="popadd"
      v-if="superInfo.activityId"
      @success="addSuccess"
      :superInfo="superInfo"
    />

    <!-- 非身份用户，权利跳转 -->
    <v-pop-jump ref="popjump" :popJumpInfo="popJumpInfo" />

    <!-- 分享 -->
    <v-share ref="share" :shareData="shareData"></v-share>

    <!-- 报名成功弹窗 -->
    <v-pop-success
      v-if="superInfo.activityId"
      ref="popsuccess"
      :superInfo="superInfo"
    />
  </section>
</template>

<script>
import { mapState } from "vuex";
import pageMixins from "@mixins/page-mixins";
import service from "@utils/service.js";
import { setStorage, getStorage } from "@utils/storage";
import {
  Toast,
  Image as VanImage,
  Popup as VanPopup,
  Picker as VanPicker,
} from "vant";
import { getQuery, getUrlParams, buildEncodeUrl } from "@utils/url";
import { formatDate } from "@utils/utils";
import VModCoupon from "@components/v-mod-coupon.vue";
import VModFtBtn from "@components/v-mod-ft-btn.vue";
import VPopGift from "@components/v-pop-gift.vue";
import VPopImg from "@components/v-pop-img.vue";
import VShare from "@/components/v-share.vue";
import VPopReg from "@components/v-pop-reg.vue";
import VPopCert from "@components/v-pop-cert.vue";
import VPopAdd from "@components/v-pop-add.vue";
import VPopJump from "@components/v-pop-jump.vue";
import { jumpPage } from "@utils/url";
import { statClick, statCv } from "@utils/h5-report";
import PostList from "@/components/club/post-list.vue";
import VPopSuccess from "@components/v-pop-success.vue";

export default {
  mixins: [pageMixins],
  components: {
    VanImage,
    VModCoupon,
    VModFtBtn,
    VPopGift,
    VPopImg,
    VShare,
    VanPopup,
    VanPicker,
    VPopReg,
    VPopCert,
    VPopAdd,
    VPopJump,
    PostList,
    VPopSuccess,
  },

  data() {
    let actid = getQuery("actId") || "";
    let superId = getQuery("superId") || "";
    return {
      autoPv: false,
      // 数管的上报
      reportData: {
        cntp: "mgcard_superLiveInfo",
        lob: {
          actid,
          superId,
          identity: 0,
        },
      },
      identity: 0, //芒果卡身份 0表示非芒果卡用户；1表示普通芒果卡用户；2表示VIP芒果卡用户
      actid,
      superId,
      // 图文链接信息
      actInfo: {},
      // 获取超级信息
      superInfo: {},
      superUserInfo: {},
      // 分享参数
      shareData: {},

      // 选择器
      value: "",
      columns: ["身份证", "护照等其他证件"],
      showPicker: false,
      // 选择器
      pickerValue: "身份证",
      // 活动时间
      actTime: "",
      // 报名开始时间
      signUpStartTime: "",
      // 报名结束时间
      signUpEndTime: "",
      // 开奖及候补开始时间
      drawStartTime: "",
      // 开奖及候补结束时间
      drawEndTime: "",
      // 是否芒果卡用户 0否, 1是
      isHit: "0",
      // 是否展示开奖提醒
      isShowRemind: false,

      gradientStyle: {},
      bgColor: "#2F6CFB", // 默认背景颜色
      gradientHomeBtnStyle: {},

      isRemind: false, // 是否展示提醒

      // 轮询
      pollType: "",
      pollInterval: null, // 轮询定时器
      pollCount: 0, // 轮询次数（可选）
      maxPollCount: 120, // 最大轮询次数（可选）
      isSearching: true,
      popJumpInfo: {},
      /** 社区相关 */
      showEmpty: false,
      postList: [],
      sameActIds: [],
      statCvClaim: false, // 上报新手弹窗cv
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    getTimeTitStyle() {
      const category = this.superInfo.activityCategory;
      if (category === 2) {
        return {
          width: "84px",
          height: "18px",
          backgroundImage: `url(${require("@/assets/image/rank/icon-time02.png")})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundPosition: "center top",
          textIndent: "-9999px",
        };
      } else if (category === 3) {
        return {
          width: "150px",
          height: "18px",
          backgroundImage: `url(${require("@/assets/image/rank/icon-time01.png")})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundPosition: "center top",
          textIndent: "-9999px",
        };
      } else {
        return {
          width: "98px",
          height: "18px",
          backgroundImage: `url(${require("@/assets/image/icon-time-gift.png")})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundPosition: "center top",
          textIndent: "-9999px",
        };
      }
    },
  },

  async mounted() {
    await this.getActivityInfo(); // 获取图文链接信息
    this.getSuperInfo("sentPv"); // 获取超级信息
    this.getActIds();

    // 使用 pageshow 事件，它在页面显示时触发，包括从缓存恢复
    window.addEventListener("pageshow", this.handlePageShow);
  },

  beforeUnmount() {
    // 清理事件监听器
    window.removeEventListener("pageshow", this.handlePageShow);
  },

  methods: {
    // 处理 pageshow 事件
    handlePageShow(e) {
      // 如果页面是从缓存恢复的（如按后退按钮返回），则刷新页面
      if (e.persisted || window.performance.navigation.type === 2) {
        window.location.reload();
      }
    },

    async getActIds() {
      await service
        .getActIds({ activityId: this.superId })
        .then((res) => {
          if (res.code !== "0000" || !res.data.list?.length) {
            this.sameActIds = [this.superId];
          } else {
            this.sameActIds = res.data.list;
          }
        })
        .catch(() => {
          this.sameActIds = [this.superId];
        })
        .then(() => {
          this.$refs["post-list"].reset();
        });
    },
    /** 社区相关 */
    async loadPosts(page, pageSize) {
      console.log("load-post", page, page);
      if (page === 1) this.showEmpty = false;
      if (page !== 1) {
        // 只请求第一页
        this.postList = [...this.postList];
        return;
      }

      await service
        .getPostListByActivity({
          page,
          pageSize,
          activityIds: this.sameActIds,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.postList = [...this.postList];
            Toast("帖子加载失败，请稍后重试");
            return;
          }
          const resData = res.data.list || [];
          this.postList = [...this.postList, ...resData];
          this.showEmpty = this.postList.length === 0;
        })
        .catch(() => {
          this.postList = [...this.postList];
          Toast("帖子加载失败，请稍后重试");
        });
    },
    // 获取图文链接信息
    async getActivityInfo() {
      let params = {
        activityId: this.actid,
      };
      const res = await service.getActivityInfo(params);
      if (res.errno === "0") {
        this.actInfo = res.data;
        this.getClaim(); // 领取新用户礼包接口
      }
    },

    // 超级现场信息
    async getSuperInfo(val) {
      let params = {
        activityId: this.superId,
      };
      const res = await service.getSuperInfo(params);
      if (res.errno === "0") {
        this.superInfo = res.data;
        this.superUserInfo = res.data.userInfo;
        const {
          performanceTime,
          signUpStartTime,
          signUpEndTime,
          drawStartTime,
          drawEndTime,
          backgroundColor,
          activityCurrentStatus,
          activityCategory,
          userInfo: { userSignupStatus, drawRemind, prizeStatus, prizeType },
        } = this.superInfo;
        if (performanceTime == "1970-01-01 00:00:00") {
          this.actTime = "";
        } else {
          this.actTime = formatDate(performanceTime, "weekday");
        }
        this.signUpStartTime = formatDate(signUpStartTime, "point");
        this.signUpEndTime = formatDate(signUpEndTime, "point");
        this.drawStartTime = formatDate(drawStartTime, "point");
        this.drawEndTime = formatDate(drawEndTime, "hhmm");

        // 倒计时结束，候补中 且 未查到结果 则不展示
        if (val == "gift") {
          if (activityCurrentStatus == 3) {
            Toast("没查到结果，请过一会再试");
            return;
          }
          if (activityCurrentStatus == 4) {
            if (prizeStatus == 0 || prizeStatus == 2) {
              Toast("未中奖，请参与其他活动吧！");
            }
            if (prizeStatus == 4) {
              Toast("未候补成功，请参与其他活动吧！");
            }
          }
          this.isSearching = !this.isSearching;
        }

        // 倒计时结束，开奖中 到 开奖完成状态，自动展示中奖弹窗
        if (val == "page") {
          if (activityCurrentStatus == 2) {
            Toast("没查到结果，请过一会再试");
            return;
          }
          // 如果是 榜单 或者 榜单+奖品且中奖类型是榜单中奖， 则不展示中奖弹窗
          if (
            activityCurrentStatus == 3 &&
            prizeStatus == 1 &&
            !(activityCategory == 3 && prizeType == 1)
          ) {
            this.$refs.popgift.open();
          }
          this.isSearching = !this.isSearching;
        }

        // 是否展示提醒,用户已报名 且未开奖 且用户未设置提醒 且已登录
        if (
          this.userInfo.uuid &&
          drawRemind == 0 &&
          userSignupStatus == 1 &&
          (activityCurrentStatus == 0 ||
            activityCurrentStatus == 1 ||
            activityCurrentStatus == 2)
        ) {
          this.isRemind = true;
        } else {
          this.isRemind = false;
        }

        // 是否展示开奖提醒
        if (
          userSignupStatus == 1 &&
          (activityCurrentStatus == 0 || activityCurrentStatus == 1)
        ) {
          this.isShowRemind = true;
        }

        this.getGradientStyle(backgroundColor); // 背景渐变样式
      } else {
        Toast(res.msg || "请稍后再试！");
      }

      if (val == "sentPv") {
        await this.getIsHit(); // 获取芒果卡身份
        // 推荐官芒果卡用户
        if (this.superUserInfo.userIdentity == 1) {
          this.identity = 2;
        }
        // 普通芒果卡用户
        if (this.superUserInfo.userIdentity != 1 && this.isHit == 1) {
          this.identity = 1;
        }
        // pv 上报
        this.reportData.lob.identity = this.identity;
        this.statPagePv();

        this.$store.commit("setIdentity", this.identity); // 设置用户身份

        // 设置分享信息
        this.setShareData();
        if (this.statCvClaim) {
          statCv(
            {
              actid: this.superId,
              identity: this.identity,
            },
            {
              mod: "c_newcomercouponpop",
            },
          );
        }
      }
    },

    // 领取新用户礼包接口
    async getClaim() {
      if (!this.userInfo.uuid) {
        return;
      }
      const claimUuid = getStorage("claim-uuid");
      if (claimUuid === this.userInfo.uuid) {
        return;
      }
      const res = await service.getClaim();
      if (res.errno === "0") {
        // 打开新手人福利弹窗
        if (this.actInfo.img1) {
          this.statCvClaim = true;
          this.$refs.popimg.open(this.actInfo.img1);
        }
        setStorage("claim-uuid", this.userInfo.uuid);
      }
    },

    // 获取芒果卡身份
    async getIsHit() {
      if (!this.userInfo.uuid) {
        return;
      }
      const res = await service.getIsHit();
      if (res.errno === "0") {
        if (!res.data.isHit) {
          this.isHit = 0;
          return;
        }
        this.isHit = res.data.isHit;
      }
    },

    // 背景渐变参数
    getGradientStyle(color) {
      if (color) {
        this.bgColor = color;
      }
      // 将 HEX 颜色转换为 RGBA
      const hexToRgba = (hex, opacity) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      // 生成渐变背景
      this.gradientStyle = {
        background: `linear-gradient(180deg, ${hexToRgba(
          this.bgColor,
          0.3,
        )} 0%, ${hexToRgba(this.bgColor, 0)} 279px)`,
      };

      // 生成home按钮背景
      this.gradientHomeBtnStyle = {
        background: `linear-gradient(315deg, ${hexToRgba(
          this.bgColor,
          0.4,
        )} 0%, ${hexToRgba(this.bgColor, 0.7)} 100%)`,
      };
    },

    // 点击俱乐部按钮
    handleHome() {
      jumpPage(this.actInfo.url5);
    },
    // 打开身份认证弹窗
    openCertPop() {
      // 展示报名弹窗
      this.$refs.popcert.open();
    },

    // 打开身份认证弹窗
    openPickerPop() {
      this.showPicker = true;
    },

    // 选择证件类型
    onConfirm(value) {
      console.log("🚀 ~ onConfirm ~ value:", value);
      this.pickerValue = value;
      this.showPicker = false;
    },

    // 我要报名弹窗
    showSignUpPopup() {
      statCv(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          mod: "c_posterconfirmpop",
        },
      );
      this.$refs.popreg.open();
    },

    handleAddPopup() {
      this.$refs.popadd.open();
    },

    addSuccess(count) {
      this.handleJoin(count);
    },
    // 参加活动接口 - 添加奖券
    async handleJoin(ticketCount) {
      let params = {
        activityId: this.superId,
        ticket: this.userInfo.ticket,
        type: 3,
        ticketCount,
      };
      const res = await service.setJoinSuper(params);
      if (res.errno === "0") {
        Toast("添加成功");
        this.getSuperInfo(); // 获取超级信息
      } else {
        Toast("做任务获得buff券吧");
      }
    },

    // 身份证认证成功，报名成功，预约成功
    async refreshSuperInfo(name) {
      // 活动开始前，用户已报名，未确认
      if (name == "page" && this.superUserInfo.userSignupStatus == 1) {
        await this.getSuperInfo("page");
        return;
      }
      if (name == "gift") {
        await this.getSuperInfo("gift"); // 获取超级信息
        return;
      }
      this.getSuperInfo();
    },

    // 领取奖励弹窗
    handleOpenGift() {
      this.$refs.popgift.open();
    },

    // 申请候补
    async handleContinue() {
      let params = {
        activityId: this.superId,
        ticket: this.userInfo.ticket,
        type: 2,
      };
      const res = await service.setJoinSuper(params);
      if (res.errno === "0") {
        Toast("申请成功");
        this.getSuperInfo(); // 获取超级信息
      } else {
        Toast(res.msg || "申请失败");
        this.$refs.popadd.close();
      }
    },

    // 中奖弹窗,确认领奖 type:1, 我要放弃 type:4
    async giftConfirm(type) {
      // 奖品类型 2=芒盒奖品 跳转填写信息页
      if (this.superInfo.prizeType == 2 && type == 1) {
        jumpPage(this.superUserInfo.jumpUrl);
        return;
      }
      // 奖品类型 1=门票
      let params = {
        activityId: this.superId,
        ticket: this.userInfo.ticket,
        type,
      };
      const res = await service.setJoinSuper(params);
      if (res.errno === "0") {
        if (type == 1) {
          Toast("已确认成功，请等待短信或客服的出票通知");
        }
        if (type == 4) {
          Toast("已放弃，还有机会参加其他活动");
        }
        this.getSuperInfo(); // 获取超级信息
        this.$refs.popgift.close();
      } else {
        Toast(res.msg);
        this.$refs.popgift.close();
      }
    },

    // 开奖提醒
    async handleRemind() {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
        },
        {
          cont: "点击提醒我",
          mod: "reminder_my",
        },
      );
      let params = {
        activityId: this.superId,
        ticket: this.userInfo.ticket,
        type: 2,
      };
      const res = await service.setSubscription(params);
      if (res.errno === "0") {
        Toast("已设置提醒，请留意短信消息");
        this.getSuperInfo(); // 获取超级信息
      } else {
        Toast(res.msg || "设置失败");
      }
    },

    // 弹窗 非身份用户，权利跳转
    handleJumpPopup(val) {
      this.popJumpInfo = val;
      this.$refs.popjump.open();
    },

    // 设置分享信息
    setShareData() {
      let link = "";
      let linkParams = getUrlParams(window.location.href);
      linkParams.cxid = "chaojixianchang";
      link = buildEncodeUrl(
        `${window.location.origin}${window.location.pathname}#/index`,
        linkParams,
      );
      this.shareData = {
        title: this.superInfo.activityName,
        desc: "报名免费得门票！芒果卡专享福利超级现场，速来！",
        imgUrl: this.superInfo.activityThumbnailImg,
        link,
      };
      // 设置wx分享参数;
      this.$nextTick(() => {
        this.$refs.share.shareInitData(this.shareData);
      });
    },

    // 报名成功
    regSuccess() {
      this.$refs.popsuccess.open();
      this.getSuperInfo();
    },

    // 盲盒填写信息
    handleBlind() {
      // 奖品类型 2=芒盒奖品 跳转填写信息页
      if (this.superInfo.prizeType == 2) {
        jumpPage(this.superUserInfo.jumpUrl);
      }
    },
  },
};
</script>

<style lang="less">
.page-index {
  padding-bottom: 80px;
  .page-index-bg {
    background-image: url("../assets/image/bg01.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
  .page-index-wrap {
    position: relative;
    padding-top: 33.5px;
    // background-image: url("../assets/image/bg.png");
    // background-repeat: no-repeat;
    // background-size: 100% auto;
    // background-position: center top;

    .btn-home {
      position: fixed;
      top: 2px;
      right: 0;
      z-index: 20;
      .arr01,
      .arr02,
      .arr03 {
        position: absolute;
        top: 2px;
        right: 0;
      }
      .arr01,
      .arr02 {
        top: 14px;
        width: 93px;
        height: 35px;
        background: #fff;
        border-radius: 50px 0px 0px 50px;
      }
      .arr02 {
        z-index: 4;
      }
      .arr03 {
        z-index: 46;
        top: 0;
        right: 0;
        width: 109px;
        height: 61px;
        background-image: url("../assets/image/icon-btn-home.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
      }
    }
    .cont {
      position: relative;
      width: 328px;
      margin: 0 auto;
      background-image: url("../assets/image/bg-piao.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
      .head {
        position: relative;
        height: 506px;
        padding-top: 19px;
        box-sizing: border-box;
        .banner {
          width: 290px;
          height: 406px;
          margin: 0 auto;
          .s {
            overflow: hidden;
            width: 100%;
            height: 100%;
            border-radius: 18px 18px 0 0;
          }
        }
        .txt-box {
          position: absolute;
          left: 0;
          bottom: 32px;
          padding: 50px 35px 0;
          width: 100%;
          box-sizing: border-box;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.83) 24%,
            #ffffff 46%,
            #ffffff 100%
          );
          .tit {
            margin-bottom: 8px;
            line-height: 1.3;
            font-weight: 600;
            font-size: 21px;
            color: #001a33;
          }
          .t1 {
            margin-bottom: 8px;
            font-weight: 400;
            font-size: 13px;
            color: #3575ff;
          }
          .t2,
          .t3 {
            font-weight: 400;
            font-size: 13px;
            color: rgba(0, 0, 0, 0.54);
          }
        }
      }
      .time-box {
        position: relative;
        z-index: 1;
        width: 320px;
        height: 203px;
        margin: 0 auto 10px;
        padding: 40px 15px 0;
        background-image: url("../assets/image/bg-time.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center -10px;
        box-sizing: border-box;

        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 37.5px;
          background: linear-gradient(
            180deg,
            #869da6 0%,
            rgba(0, 0, 0, 0) 100%
          );
          opacity: 0.05;
        }
        .txt {
          font-weight: 400;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.6);
        }

        .time {
          margin-bottom: 20px;
          .tit {
            width: 59px;
            height: 18px;
            margin-bottom: 10px;
            text-indent: -9999px;
            background-image: url("../assets/image/icon-time-reg.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
            background-position: center top;
            box-sizing: border-box;
          }
        }
        .gift {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .order {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 79px;
              height: 24px;
              font-weight: 400;
              font-size: 11px;
              color: #001a33;
              background-image: url("../assets/image/icon-time-order.png");
              background-repeat: no-repeat;
              background-size: 100% auto;
              background-position: center top;
              box-sizing: border-box;
            }
          }
        }
      }
    }

    .rule-box {
      .s {
        width: 100%;
      }
    }
  }

  .m-add-ticket {
    padding: 20px 30px 50px;
    .list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 45px;
        background: #ff5f00;
        background: linear-gradient(180deg, #ff8740 0%, #ff5f00 100%);
        box-shadow: 0 4px 16px 0 rgba(251, 125, 85, 0.39);
        border-radius: 22px;
        font-size: 17px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .section-header {
    line-height: 53px;
    font-size: 13px;
    font-weight: 500;
    margin: 0 15px;
    margin-bottom: -10px;
    color: #001a33;
  }
}
</style>
